module.exports = __webpack_public_path__ + "assets/img/Ic-WeChat.acd3f3f5.svg";